import classNames from 'classnames'

import { Button } from 'core-components/library/button'

import styles from './ApplySettingsArea.module.scss'
import { useContext } from 'react'
import { FlexGridWrapperActionsContext } from 'core-components/sitebuilder/layout/flexGridWrapper/context/FlexGridWrapperActionsContext'

interface IApplySettingsArea {
  onClose: () => void
  version?: string
}

export const ApplySettingsArea = ({ version, onClose }: IApplySettingsArea) => {
  const { resetToDefault } = useContext(FlexGridWrapperActionsContext)

  return (
    <div className={styles['version']}>
      <div className={styles['versionInfo']}>
        <p>Outdated: {version}</p>
        <i
          onClick={onClose}
          className={classNames('kbase kbase-close kbase-xs', styles.closeBtn)}
        />
      </div>
      <div className={styles['applyBtnWrapper']}>
        <Button
          variant="contained"
          className={styles['applyBtn']}
          onClick={resetToDefault}
          color="primary"
        >
          Apply new settings
        </Button>
      </div>
    </div>
  )
}
